import Box from '@mui/material/Box';
import MaterialTable from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import MaterialTableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { palette } from '@openx/components-core/lib/theme/paletteV2';
import type { NoDataComponentProps } from '@openx/components-table/parts/sections/DataSection';
import { TableHeader } from '@openx/components-table/parts/TableHeader';
import type { BaseRow } from '@openx/types/tableHelpers';
import { noop } from '@openx/utils/noop';
import { useTranslation } from 'react-i18next';

export const NoDataComponent = <RowT extends BaseRow>({
  headerColumns,

  sortCriteria,
  stickyTable,
  overrideTableCellStyles,
}: NoDataComponentProps<RowT>) => {
  const { t } = useTranslation();

  return (
    <MaterialTable>
      <TableHeader
        onChange={noop}
        columns={headerColumns}
        criteria={sortCriteria}
        stickyTable={stickyTable}
        overrideTableCellStyles={overrideTableCellStyles}
      />
      <TableBody data-test="table-body">
        <MaterialTableRow>
          <TableCell colSpan={headerColumns.length}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: 440,
                width: '100%',
                gap: 0.5,
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  fontWeight: 'fontWeightBold',
                  fontSize: 16,
                }}
              >
                {t('No data available')}
              </Typography>
              <Typography variant="body1" color={palette.text.secondary}>
                {t('Try adjusting filters or date range to see the results.')}
              </Typography>
            </Box>
          </TableCell>
        </MaterialTableRow>
      </TableBody>
    </MaterialTable>
  );
};
